import { voucherConstants } from '../_constants/voucherConstants';

const initialState = {};
const vouchers = [];
const vouchersState = {
  loading: false,
  error: null,
  data: []
};

/**
 * Reducer for handling a single selected voucher
 */
export function selectVoucher(state = initialState, action) {
  switch (action.type) {
    case voucherConstants.SELECT_VOUCHER:
      return action.data;
    default:
      return state;
  }
}

/**
 * Reducer for handling the list of selected vouchers
 */
export function selectedVoucherList(state = vouchers, action) {
  switch (action.type) {
    case voucherConstants.SELECTED_VOUCHER_LIST:
      return action.data;
    default:
      return state;
  }
}

/**
 * Reducer for handling voucher list fetching state
 */
export function voucherList(state = vouchersState, action) {
  switch (action.type) {
    case voucherConstants.GET_VOUCHERS:
      return {
        ...state,
        loading: true,
        error: null
      };
    case voucherConstants.GET_VOUCHERS_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.data
      };
    case voucherConstants.GET_VOUCHERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}

/**
 * Reducer for handling voucher fetching by code
 */
export function voucherByCode(state = { loading: false, error: null, data: null }, action) {
  switch (action.type) {
    case voucherConstants.GET_VOUCHER_BY_CODE:
      return {
        ...state,
        loading: true,
        error: null
      };
    case voucherConstants.GET_VOUCHER_BY_CODE_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.data
      };
    case voucherConstants.GET_VOUCHER_BY_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null
      };
    default:
      return state;
  }
}

/**
 * Reducer for handling voucher fetching by redemption code
 */
export function voucherByRedemptionCode(state = { loading: false, error: null, data: null }, action) {
  switch (action.type) {
    case voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE:
      return {
        ...state,
        loading: true,
        error: null
      };
    case voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.data
      };
    case voucherConstants.GET_VOUCHER_BY_REDEMPTION_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null
      };
    default:
      return state;
  }
}